// Phase 1C — skew retry budget.
//
// One "load cycle" spans: an initial multi-tile refresh + AT MOST ONE targeted
// skew retry. The retry itself must not create a new budget, so changing the
// observed range 100–105 → 103–106 → 104–107 during the SAME cycle must still
// result in exactly one skew retry.
//
// Extracted as a small production class so tests exercise the actual code
// GridViewer uses.

export class SkewRetryBudget {
  private cycleId: number;
  private used: boolean;

  constructor(cycleId: number = 0) {
    this.cycleId = cycleId;
    this.used = false;
  }

  /** Begin a fresh load cycle. Grants a new skew retry. */
  beginCycle(newCycleId: number): void {
    this.cycleId = newCycleId;
    this.used = false;
  }

  /** Current cycle id (read-only accessor for tests). */
  get id(): number {
    return this.cycleId;
  }

  /** True after claim() has succeeded in the current cycle. */
  get retryUsed(): boolean {
    return this.used;
  }

  /**
   * Try to claim the ONE skew retry allowed for cycle `cycleId`.
   * Returns true if the caller may perform the retry, false otherwise.
   * A mismatched cycleId (stale claim) is rejected.
   */
  claim(cycleId: number): boolean {
    if (cycleId !== this.cycleId) return false;
    if (this.used) return false;
    this.used = true;
    return true;
  }
}
